module.exports = __webpack_public_path__ + "img/user (2).ca3a1184.png";